export const telegramValidator = /(^(t\.me\/[-a-zA-Z0-9]{1,20})|(^\+?\d*$))/;
export const symbolsValidator = /^([aA-zZ0-9-_/|\\]+ ?)*$/;
export const urlValidator =
	/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/;
